// src/pages/DiagnosisCodes.js
import React, { useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Divider,
} from "@mui/material";
import PatientHeader from "../../components/PatientHeader/PatientHeader";

// Sample data for a mock patient profile
const exampleProfile = {
  dob: "01/01/1980",
  lastPcpVisit: "06/01/2024",
  opportunityScore: "Score",
  erVisits: 0,
  admits: 0,
  age: 44,
};

// Mock data for diagnosis codes
const diagnosisData = [
  {
    date: "01/01/2024",
    code: "A01",
    description: "Sample Diagnosis",
    hcc: "HCC1",
  },
  {
    date: "02/01/2024",
    code: "A02",
    description: "Sample Diagnosis 2",
    hcc: "HCC2",
  },
];

const DiagnosisCodes = () => {
  // State holding the patient profile and diagnosis data (mock)
  const [patientProfile] = useState(exampleProfile);
  const [diagnosisCodes] = useState(diagnosisData);

  return (
    <div style={{ margin: "50px auto", width: "80%" }}>
      <Paper elevation={3} style={{ padding: "20px" }}>
        {/* Patient Header */}
        <PatientHeader
          dob={patientProfile.dob}
          lastPcpVisit={patientProfile.lastPcpVisit}
          opportunityScore={patientProfile.opportunityScore}
          erVisits={patientProfile.erVisits}
          admits={patientProfile.admits}
          age={patientProfile.age}
        />
        <Divider />

        {/* Diagnosis Codes Section */}
        <Box marginTop={4}>
          <Typography variant="h5" align="center">
            Diagnosis Codes
          </Typography>

          <TableContainer component={Paper} style={{ marginTop: "20px" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Diag Code</TableCell>
                  <TableCell>Diagnosis Description</TableCell>
                  <TableCell>HCC</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {diagnosisCodes.length > 0 ? (
                  diagnosisCodes.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.date}</TableCell>
                      <TableCell>{row.code}</TableCell>
                      <TableCell>{row.description}</TableCell>
                      <TableCell>{row.hcc}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No diagnosis codes found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>
    </div>
  );
};

export default DiagnosisCodes;
